<template>
<div class="chapter">
<div class="inner_page">
<div class="forward" id="AC_">
<p class="center" id="pz13-1">
<i>The gifts he gave were that some would be apostles, some prophets, some evangelists,
					some pastors and teachers, to equip the saints for the work of ministry, for building
					up the body of Christ, until all of us come to the unity of the faith and of the
					knowledge of the Son of</i> <span id="pz13-2">
<i>God, to maturity, to the measure of the full stature of Christ.</i> </span></p>
<p class="center" id="pz13-3">
					(Eph. 4:11–13 <span class="small">NRSV</span>) </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter04.vue?68a03263